import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import user from './modules/user'
import country from './modules/country'
import job from './modules/job'
import category from './modules/category'
import comment from './modules/comment'
import device from './modules/device'
import payment from './modules/payment'
import account from './modules/account'
import site from './modules/site'
import board from './modules/board'
import faq from './modules/faq'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    country,
    job,
    category,
    comment,
    device,
    payment,
    account,
    site,
    faq,
    board
  },
  state: {
    controls: {
      showDrawer: true
    }
  },
  mutations: {
    toggleDrawer(state, value) {
      state.controls.showDrawer = value
    }
  }
})
